/**
 * Backend permission strings from GET /users/profile.
 * UI gating only — the API must enforce authorization.
 */
export const PERMISSIONS = {
  // Reporting
  SETTINGS_VIEW_PRODUCT: "settings.view_product",
  HISTORY_VIEW_REPORT: "history.view_report",
  HISTORY_ADD_REPORT: "history.add_report",
  ORDERS_VIEW_MARKETING_HOLDER: "orders.view_marketingholder",
  ORDERS_VIEW_WHOLESALER: "orders.view_wholesaler",
  // User Management
  USERS_VIEW_USER: "users.view_user",
  USERS_CHANGE_USER: "users.change_user",
  USERS_ADD_USER: "users.add_user",
  USERS_DELETE_USER: "users.delete_user",
  USERS_VIEW_USERMEDICATION: "users.view_usermedication",
  HCP_VIEW_HOSPITAL: "hcp.view_hospital",
  // Audit Trail
  USERS_VIEW_AUDIT_TRAIL: "users.view_audit_trail",
  // PAF review
  USERS_REVIEW_PAF: "users.review_paf",
  SETTINGS_VIEW_REVIEW_OUTCOME_OPTION: "settings.view_reviewoutcomeoption",
  // PAF edit
  PRESCRIPTIONS_CHANGE_PRESCRIPTION: "prescriptions.change_prescription",
};

/**
 * Navbar / route features gated by permissions.
 * - anyOf: user needs at least one listed permission
 */
export const FEATURES = {
  REPORTING: "reporting",
  /** View User Management page and list users. */
  USER_MANAGEMENT: "userManagement",
  /** Edit users and activate/deactivate accounts. */
  USER_MANAGEMENT_CHANGE: "userManagementChange",
  /** Activate/deactivate registered products per user. */
  USER_MANAGEMENT_MEDICATION: "userManagementMedication",
  USER_MANAGEMENT_ADD: "userManagementAdd",
  USER_MANAGEMENT_DELETE: "userManagementDelete",
  HOSPITALS_VIEW: "hospitalsView",
  /** View the Audit Trail nav item and page. */
  AUDIT_TRAIL: "auditTrail",
  /** Submit a PAF review (users.review_paf). */
  PAF_REVIEW: "pafReview",
  /** Load review outcome options (settings.view_reviewoutcomeoption). */
  REVIEW_OUTCOME_OPTIONS: "reviewOutcomeOptions",
  /** Edit a prescription / PAF (prescriptions.change_prescription). */
  PAF_EDIT: "pafEdit",
};

export const FEATURE_ACCESS = {
  [FEATURES.REPORTING]: {
    anyOf: [PERMISSIONS.HISTORY_VIEW_REPORT],
  },
  [FEATURES.USER_MANAGEMENT]: {
    anyOf: [PERMISSIONS.USERS_VIEW_USER],
  },
  [FEATURES.USER_MANAGEMENT_CHANGE]: {
    anyOf: [PERMISSIONS.USERS_CHANGE_USER],
  },
  [FEATURES.USER_MANAGEMENT_MEDICATION]: {
    anyOf: [PERMISSIONS.USERS_VIEW_USERMEDICATION],
  },
  [FEATURES.USER_MANAGEMENT_ADD]: {
    anyOf: [PERMISSIONS.USERS_ADD_USER],
  },
  [FEATURES.USER_MANAGEMENT_DELETE]: {
    anyOf: [PERMISSIONS.USERS_DELETE_USER],
  },
  [FEATURES.HOSPITALS_VIEW]: {
    anyOf: [PERMISSIONS.HCP_VIEW_HOSPITAL],
  },
  [FEATURES.AUDIT_TRAIL]: {
    anyOf: [PERMISSIONS.USERS_VIEW_AUDIT_TRAIL],
  },
  [FEATURES.PAF_REVIEW]: {
    anyOf: [PERMISSIONS.USERS_REVIEW_PAF],
  },
  [FEATURES.REVIEW_OUTCOME_OPTIONS]: {
    anyOf: [PERMISSIONS.SETTINGS_VIEW_REVIEW_OUTCOME_OPTION],
  },
  [FEATURES.PAF_EDIT]: {
    anyOf: [PERMISSIONS.PRESCRIPTIONS_CHANGE_PRESCRIPTION],
  },
};

export default PERMISSIONS;
